import Vue from 'vue'
import Vuex from 'vuex'
import auth from '@/modules/authentication'
import estados from '@/modules/estados'
import bicis from '@/modules/bicis'

import reservas from '@/modules/reservas'
import clientes from '@/modules/clientes'
import tarifas from '@/modules/tarifas'
import disponibilidad from '@/modules/disponibilidad'
import reparaciones from '@/modules/reparaciones'
import reportes from '@/modules/reportes'
import mensajes from '@/modules/mensajes'
import ingresos from '@/modules/ingresos'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    dark: true,
    pantallaActiva: null,

    puntosDevolucion: ["Santiago", "Fisterra", "León", "Ponferrada", "Oporto", "Saint Jean"],
    marcasBici: ["BIANCHI", "CUBE", "HAIBIKE"], 
    
    drawer: false,

    colorEBikeFondo: '#D4D6D9',
    colorEBikeBarraFormulario: '#455A64',
    colorEBikeAccent1: '#2196F3',

    colorDark500: '#212226',
    colorDark400: '#2A2B2D',
    colorDark300: '#303136',
    colorDark200: '#363940',
    colorDark100: '#40454B',

    colorLight500: '#FFFFFF',
    colorLight400: '#F2F3F5',
    colorLight300: '#E4E6E9',
    colorLight200: '#D1D4D9',
    colorLight100: '#51575F',

    colorFondo500: '#212226',
    colorFondo400: '#2A2B2D',
    colorFondo300: '#303136',
    colorFondo200: '#363940',
    colorFondo100: '#40454B',

    colorFront500: '#FFFFFF',
    colorFront400: '#F2F3F5',
    colorFront300: '#E4E6E9',
    colorFront200: '#D1D4D9',
    colorFront100: '#51575F',

    colorAccent1: '#17A85D',
    colorAccent2: '#012D5A',
    
    colorBarraFormulario:"blue-grey darken-2",

   
  },
  mutations: {
    setLoading (state, bool){
      state.loading = bool
    },

    setDrawer (state, value){
      state.drawer = value;
    },

    setDark (state, bool){
      state.dark = bool;
      if (state.dark){
        state.colorFondo500 = state.colorDark500;
        state.colorFondo400 = state.colorDark400;
        state.colorFondo300 = state.colorDark300;
        state.colorFondo200 = state.colorDark200;
        state.colorFondo100 = state.colorDark100;

        state.colorFront500 = state.colorLight500;
        state.colorFront400 = state.colorLight400;
        state.colorFront300 = state.colorLight300;
        state.colorFront200 = state.colorLight200;
        state.colorFront100 = state.colorLight100;
      }else{
        state.colorFondo500 = state.colorLight500;
        state.colorFondo400 = state.colorLight400;
        state.colorFondo300 = state.colorLight300;
        state.colorFondo200 = state.colorLight200;
        state.colorFondo100 = state.colorLight100;

        state.colorFront500 = state.colorDark500;
        state.colorFront400 = state.colorDark400;
        state.colorFront300 = state.colorDark300;
        state.colorFront200 = state.colorDark200;
        state.colorFront100 = state.colorDark100;

      }
    }
  },
  actions: {
    


  },
  modules: {
    auth, reservas, clientes, bicis, 
    estados, tarifas, disponibilidad, reparaciones, reportes, mensajes, ingresos
  }
})
